import { useAuth, useTenant } from '@/contexts'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Plane, Warehouse, Map } from 'lucide-react'

export function DashboardPage() {
  const { user } = useAuth()
  const { currentOrganization, currentLocation, isLoading } = useTenant()

  const displayName = user?.user_metadata?.display_name || user?.email?.split('@')[0] || 'there'

  return (
    <div className="space-y-6">
      {/* Welcome header */}
      <div>
        <h1 className="text-3xl font-bold tracking-tight">
          Welcome back, {displayName}!
        </h1>
        <p className="text-muted-foreground">
          {isLoading ? (
            'Loading your organization...'
          ) : currentOrganization ? (
            <>
              Managing{' '}
              <span className="font-medium">{currentOrganization.name}</span>
              {currentLocation && (
                <>
                  {' '}at{' '}
                  <span className="font-medium">{currentLocation.name}</span>
                </>
              )}
            </>
          ) : (
            'No organization selected'
          )}
        </p>
      </div>

      {/* Placeholder cards */}
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Aircraft</CardTitle>
            <Plane className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">--</div>
            <CardDescription>
              Coming soon - View and manage your aircraft fleet
            </CardDescription>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Hangars</CardTitle>
            <Warehouse className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">--</div>
            <CardDescription>
              Coming soon - Monitor hangar occupancy and availability
            </CardDescription>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Map View</CardTitle>
            <Map className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">3D</div>
            <CardDescription>
              Coming soon - Interactive 3D hangar visualization
            </CardDescription>
          </CardContent>
        </Card>
      </div>

      {/* Getting started section */}
      <Card>
        <CardHeader>
          <CardTitle>Getting Started</CardTitle>
          <CardDescription>
            Your PlaneMAX Customer Portal is ready. Here&apos;s what&apos;s coming next:
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ul className="list-disc list-inside space-y-2 text-sm text-muted-foreground">
            <li>3D hangar visualization with aircraft placement</li>
            <li>Aircraft fleet management</li>
            <li>Hangar occupancy tracking</li>
            <li>Customer and client management</li>
            <li>Real-time collaboration features</li>
          </ul>
        </CardContent>
      </Card>
    </div>
  )
}
